import React, { useEffect, useState } from 'react';

import Navbar from '../../Components/Navbar/Navbar';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';


import { 
  Delete,
  PersonPin,
} from '@mui/icons-material';
import { 
    Layout,
    Table,
    Col, 
    Row,
    Button,
    Form,
    Select,
    Input,
    // InputNumber,
    Upload,
    DatePicker,
    Space,
    Popover,
    InputNumber,
} from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { capitalizeText, checkAddingDatePerMonth, formatAmount, formatDate } from '../../Utils/Common';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests';
import { usePostRequest } from '../../hooks/usePostRequest';


const { RangePicker } = DatePicker;
const { TextArea } = Input;
const { Option } = Select;
const { Item } = Form;

const AddBilling = () => {
  const [addBillingForm] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { type } = useParams();
  const [tenantData, setTenantData] = useState([]);
  const [tenantBilling, setTenantBilling] = useState([]);
  const [billingDetails, setBillingDetails] = useState([]);
  const [discountData, setDiscountData] = useState([]);
  const [billingItem, setBillingItem] = useState([]);
  const [tenantId, setTenantId] = useState('');
  const [unitId, setUnitId] = useState('');
  const [ownerDetails, setOwnerDetails] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [rentalData, setRentalData] = useState([]);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [open, setOpen] = useState(false);
  // const [isAddRow, setIsAddRow] = useState(false)
  const [filterConfig, setFilterConfig] = useState({
    rental_unit_id: location?.state ? location?.state?.rental_unit_id : '',
    property_id: location?.state ? location?.state?.property : '',
    tradename: location?.state ? location?.state?.tradename : '',
  })

  const { callPost, loading, data } = usePostRequest(()=>{
    // navigate('preview-billing/'+ type +'/' + data?.billing_id)
  });

  React.useEffect(() => {
    if (data) {
      navigate('/preview-billing/'+ type +'/' + data?.billing_id);
    }
  }, [data, navigate, type]);

  const billingValues = addBillingForm.getFieldsValue();
  const values = Form.useWatch([], addBillingForm);

  const handleDeleteAttachment = (file) => {
    const updatedAttachments = attachmentsData.filter(item => item !== file);
    setAttachmentsData(updatedAttachments);
  };

  React.useEffect(() => {
      addBillingForm.validateFields({
      validateOnly: true,
          }).then(() => {
              setIsDisabled(false)
          },
          () => {
              setIsDisabled(true)
          },
      );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, addBillingForm,]);
  useEffect(() => {
    if(tenantId && billingValues?.date_range){
      fetchBillingMeter(tenantId,billingValues?.date_range[0]?.format('YYYY-MM-DD'),billingValues?.date_range[1]?.format('YYYY-MM-DD'), unitId)

    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId, billingValues?.date_range, unitId]);
  useEffect(() => {
    if(location?.state){
      setTenantId(location?.state?.tradename)
      setUnitId(location?.state?.rental_unit_id)
    }
  }, [location]);

  const defaultColumns = [
    {
      title: 'Description',
      dataIndex: 'description',
      render: (_, record, index) => (
        record.isRowAdded ? (
          <Form>
            <Item 
              // name={['tenantBilling', index, 'description']}
            >
              <Select 
                placeholder="Select a Billing Item"
                showSearch
                style={{ width: 200 }}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={(e) => handleRentalType(e, record)}
              >
                {billingItem.map((option) => (
                  <Option key={option.id} value={option.id}>{option.description}</Option>
                ))}
              </Select>
            </Item>
          </Form>
        ) : capitalizeText(record.description)
      ),
    },
    {
      title: 'Principal Amount(Php)',
      dataIndex: 'principal_amount',
      align: 'right',
      render: (_, record, index) => (
        record.isRowAdded ? (
          <Form>
            <Item 
              // name={['tenantBilling', index, 'discount']}
              onChange={(e) => handleBasicRent(e, record)}
            >
              <InputNumber
                style={{ width: 150 }}
              />
            </Item>
          </Form>
        ) : formatAmount(record.principal_amount)
      ),
    },
    {
      title: 'VAT(Php)',
      dataIndex: 'vat',
      align: 'right',
      render: (vat) => formatAmount(vat),
    },
    {
      title: 'Withholding Tax(Php)',
      dataIndex: 'wtax',
      align: 'right',
      render: (wtax) => formatAmount(wtax),
    },
    {
      title: 'Subtotal',
      dataIndex: 'subtotal',
      align: 'right',
      render: (subtotal) => formatAmount(subtotal),
    },
    {
      title: 'Discount',
      align: 'right',
      render: (_, record) => {
        return (
          <Form 
            // form={addBillingForm}
            // initialValues={{escalation: escalationAlfresco[record.key]}}
          >
            <Item
                name="discount"
            >
              <Select 
                placeholder="Select a Discount"
                showSearch
                style={{ width: 200 }}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={(e) => handleDiscount(e, record)}
                allowClear
              >
                {discountData.map((option) => (
                  <Option key={option.id} value={option.id}>{option.name}</Option>
                ))}
              </Select>
            </Item>
          </Form>
        );
      },
    },
    {
      title: 'Discount Amount(Php)',
      dataIndex: 'discount_amount',
      align: 'right',
      render: (discount_amount) => formatAmount(discount_amount),
    },
    {
      title: 'Amount Due(Php)',
      dataIndex: 'amount_due',
      align: 'right',
      render: (amount_due) => formatAmount(amount_due),
    },
    {
      title: '',
      dataIndex: '',
      render: (_, record, index) => (
        record.isRowAdded ? (
          <div onClick={() => handleDelete(index)}>
              <Delete  
                style={{
                  color: 'red',
                }}
              />
          </div>
        ) : "-"
      ),
    },
  ];

  const handleDelete = (key) => {
    const newData = [...tenantBilling];
    newData.splice(key, 1); 
    setTenantBilling(() => newData)
  };
  
  const addRow = () => {
    const newData = [...tenantBilling];
    const nextIndex = newData?.length;
    newData.push({
      index: nextIndex,
      description: '',
      year: '',
      percentage: '0',
      escalation: '',
      principal_amount: '0.00',
      vat: '0.00',
      wtax: '0.00',
      discount: '',
      subtotal: '0.00',
      discount_amount: '0.00',
      amount_due: '0.00',
      type: 'billing_item',
      isRowAdded: true,
    });
    setTenantBilling(newData);
  };
  
  async function fetchPropertyData() {

    const response = await UseGetRequest("properties/get", {property_id: ''});
    if (response?.data) {
      setPropertyData(response?.data?.data);
    } else {
      setPropertyData([])
    }

  }

  async function fetchRentalData() {

     if(type === "owner") {
      const response = await UseGetRequest("rental_units/get", filterConfig);
      if (response?.data) {
        setRentalData(response?.data?.data);
      } else {
        setRentalData([])
      }
     } else {
      const response = await UseGetRequest("rental_units/get_renter",filterConfig);
      if (response?.data) {
        setRentalData(response?.data?.data);
      } else {
        setRentalData([])
      }
     }

  }

  const disabledDate = current => {
    const dateToDisable = dayjs(billingDetails?.date_to, 'YYYY/MM/DD').add(1, 'day');
    return current && current.isBefore(dateToDisable, 'day');
  };

  async function fetchLastBilling() {
    // setIsLoading(true)
    const response = await UseGetRequest("billings/get_rental_unit_last_billing", {
      rental_unit_id: filterConfig?.rental_unit_id, 
      renter_id: filterConfig?.renter_id,
      tenant_id: tenantId,
    });
    if (response?.data) {
        const details = response?.data?.data
        setBillingDetails(details);
        if(details?.date_to){
          addBillingForm.setFieldsValue({
            // date_range: [
            //     dayjs(details?.date_to, 'YYYY/MM/DD').add(1, 'day'),
            //     dayjs(details?.date_to, 'YYYY/MM/DD').add(1, 'month'),
            // ],
            date_range: [
              dayjs(details.date_to, 'YYYY/MM/DD').add(1, 'day'),
              checkAddingDatePerMonth(details)
              // details.date_from === details.date_to ? dayjs(details.date_from, 'YYYY/MM/DD').add(1, 'month') : dayjs(details.date_from, 'YYYY/MM/DD').add(details.months_covered, 'month').subtract(1, 'day'),
            ],
          });
        }

    } else {
      setBillingDetails([])
    }

    // setIsLoading(false);
  }

  async function fetchOwnerLastBilling(id) {
    // setIsLoading(true)
    const response = await UseGetRequest("billings/get_owner_last_billing", {owner_id: id});
    if (response?.data) {
        const details = response?.data?.data
        setBillingDetails(details);
        addBillingForm.setFieldsValue({
            date_range: [
                dayjs(details.date_to, 'YYYY/MM/DD').add(1, 'day'),
                dayjs(details.date_to, 'YYYY/MM/DD').add(1, 'month'),
                // dayjs(details.date_to, 'YYYY/MM/DD'),
            ],
        });

    } else {
      setBillingDetails([])
    }

    // setIsLoading(false);
  }

  const handleProperty = (id) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        property_id: id || ''
      }
    ));
  }

  const handleRentalUnit = (rental_id) => {
    const rental_data = rentalData.filter((item) => item.id === rental_id);
    if(type === "tenant"){
      const tenant_data = tenantData.filter((item) => {
        const targetId = rental_data[0]?.last_renter?.id;
        return item.id === targetId;
      });
      addBillingForm.setFieldsValue({
        tradename: tenant_data[0]?.id,
        property: rental_data[0]?.property_id || "",
        tin: tenant_data[0]?.tin,
        tenant_remarks: tenant_data[0]?.remarks,
        business_name: tenant_data[0]?.business_name,
      });
      setTenantId(tenant_data[0]?.id)
      setUnitId(rental_id)
      setFilterConfig((prev) => (
        {
          ...prev,
          rental_unit_id: rental_id || '',
          renter_id: tenant_data[0]?.renter_id || '',
          property_id: rental_data[0]?.property_id || '',
          tradename: type==="tenant" ? tenant_data[0]?.id : tenant_data[0]?.owner_id,
        }
      ));
    } else if(type === "owner") {
      addBillingForm.setFieldsValue({
        property: rental_data[0]?.property_id || "",
        tradename: rental_data[0]?.owner_id,
        // tenant_name: rental_data[0]?.tenant_name,
        // basic_rent: rental_data[0]?.basic_rent,
        // lease_term: rental_data[0]?.lease_term + " ("+rental_data[0]?.lease_type +")",
        // contract_period: rental_data[0]?.contract_sign_date + "-" + rental_data[0]?.contract_end_date,
      });
      setOwnerDetails(rental_data[0])
      // if(rental_data[0]?.status === "occupied"){
      //   setOpen(true)
      // } else {
      //   setOpen(false)
      // }
      if(type === "owner" && rental_data[0]?.status === "occupied"){
        setOpen(true)
      } else {
        setOpen(false)
      }
      setUnitId(rental_id)
      setTenantId(rental_data[0]?.owner_id)
    } else {
   
    }
  }
  const handleOpenPin = () => {
    setOpen(!open)
  }

  const handleTenant = (tenant_id) => {
    const newData = tenantData.filter((item) => item.id === tenant_id);
    if(type === "tenant"){
      setTenantId(newData[0]?.id)
      // setUnitId(newData[0]?.rental_unit_id)
      addBillingForm.setFieldsValue({
        tin: newData[0]?.tin,
        business_name: newData[0]?.business_name,
        rental_unit_id: newData[0]?.rental_unit_id,
        property: newData[0]?.property_id,
      });
      setFilterConfig((prev) => (
        {
          ...prev,
          rental_unit_id: newData[0]?.rental_unit_id,
          property_id: newData[0]?.property_id,
          tradename: newData[0]?.id,
          renter_id: newData[0]?.renter_id,
        }
      ));
    } else if(type === "owner") {
      fetchOwnerLastBilling(tenant_id)
      setTenantId(newData[0]?.owner_id)
      setFilterConfig((prev) => (
        {
          owner_id: newData[0]?.id,
          rental_unit_id: '',
          property_id: '',
        }
      ));
      addBillingForm.setFieldsValue({
        rental_unit_id: '',
        property: '',
      });
    } else {
      setTenantBilling([])
    }
  }

  const handleDiscount = (tenant_id, data) => {
    if(tenant_id){
      const newData = discountData.filter((item) => item.id === tenant_id);
      if(newData){
        if(newData[0]?.percentage){
          setTenantBilling(prevState => {
            const newState = [...prevState];
            newState[data.index] = { 
              ...newState[data.index], 
              discount_item_id: newData[0]?.id,
              discount_amount: (parseFloat(data?.subtotal) * (parseFloat(newData[0]?.percentage) / 100 )).toFixed(2),
              amount_due: (parseFloat(data?.principal_amount) - (parseFloat(data?.subtotal) * (parseFloat(newData[0]?.percentage) / 100 ))).toFixed(2),
            };
            return newState;
          });
        } else {
          setTenantBilling(prevState => {
            const newState = [...prevState];
            newState[data.index] = { 
              ...newState[data.index], 
              discount_item_id: newData[0]?.id,
              discount_amount: (parseFloat(newData[0]?.fixed_price)).toFixed(2),
              amount_due: ((parseFloat(data?.subtotal) - (parseFloat(newData[0]?.fixed_price)))).toFixed(2),
            };
            return newState;
          });
        }
      }
    } else {
      setTenantBilling(prevState => {
        const newState = [...prevState];
        newState[data.index] = { 
          ...newState[data.index], 
          // discount_item_id: newData[0]?.id,
          discount_amount: (parseFloat(data?.subtotal) * (parseFloat(0) / 100 )).toFixed(2),
          amount_due: (parseFloat(data?.principal_amount) - (parseFloat(data?.subtotal) * (parseFloat(0) / 100 ))).toFixed(2),
        };
        return newState;
      });
    }
  }

  const handleRentalType = (tenant_id, data) => {
    const newData = billingItem.filter((item) => item.id === tenant_id);

    if(newData){
      setTenantBilling(prevState => {
        const newState = [...prevState];
        newState[data.index] = { 
          ...newState[data.index], 
          description: newData[0]?.description,
          vat: newData[0]?.vat,
          wtax: newData[0]?.withholding_tax,
          id: newData[0]?.id
        };
        return newState;
      });
    }
  }

  const handleBasicRent = (e, record) => {
    const {value} = e.target
    setTenantBilling(prevState => {
      const newState = [...prevState];
      newState[record.index] = { 
        ...newState[record.index], 
        principal_amount: value,
        subtotal: (parseFloat(value) + parseFloat(record.vat) - parseFloat(record.wtax)),
        discount_amount: (parseFloat(value) * (parseFloat(record?.percentage) / 100 ).toFixed(2)),
        amount_due: ((parseFloat(value) + parseFloat(record.vat) - parseFloat(record.wtax)) - (parseFloat(value) * (parseFloat(record?.percentage) / 100 ))).toFixed(2),
      };
      return newState;
    });
  }

  async function fetchTenantData() {
    const response = await UseGetRequest("tenants/get", {tenant_id: '', rental_unit_id: unitId, for_billing: "1"});

    if (response?.data) {
      setTenantData(response?.data?.data);
    } else {
      setTenantData([])
    }
  }

  async function fetchOwnerData() {
    // const response = await UseGetRequest("owners/with_billings");
    const response = await UseGetRequest("owners/get", {rental_unit_id: unitId});

    if (response?.data) {
      // const owner_data = response?.data?.data?.map((data) => ({
      //   id: data.id,
      //   owner_id: data.owner_id,
      //   trade_name: data.owner_name,
      //   rental_unit_id: data.rental_unit_id,
      //   rental_unit_name: data.rental_unit_name,
      //   concat_owner: data.concat_owner,
      // }))
      setTenantData(response?.data?.data);
    } else {
      setTenantData([])
    }
  }

  async function fetchDiscountData  () {
    const response = await UseGetRequest("discount_items/get", {discount: '', name: ''});
    if (response?.data) {
      setDiscountData(response?.data?.data);
    } else {
      setDiscountData([])
    }
  }

  async function fetchBillingItem  () {
    const response = await UseGetRequest("billing_items/get", {billing_item_id: ''});
    if (response?.data) {
      setBillingItem(response?.data?.data);
    } else {
      setBillingItem([])
    }
  }
  async function fetchBillingMeter(tenant_billing_id, start_period, end_period, unit_id) {
    setIsLoading(true)
    const response = await UseGetRequest("billings/get_billing_info", {
      ...(type === "owner" ? { owner_id: tenant_billing_id } : { tenant_id: tenant_billing_id }),
      date_from: start_period,
      date_to: end_period,
      rental_unit_id: unit_id,
    });
    
    if (response?.data) {
      const data = response?.data?.data?.map((info,index) => {
        const sub_total = (parseFloat(info.principal_amount) + parseFloat(info.vat) - parseFloat(info.wtax)).toFixed(2)
        return {
          index: index,
          type: info.type,
          description: info.description,
          id: info.id,
          year: info.year,
          principal_amount: info.principal_amount,
          vat: info.vat,
          wtax: info.wtax,
          subtotal: sub_total,
          amount_due: info.amount_due || sub_total,
          discount_amount: 0.00
        };
      });
     
      setTenantBilling(data);
    } else {
      response?.error?.data?.messages?.error_messages?.map((error) => (
        toast.error(error)
      ))
      setTenantBilling([]);
    }
    setIsLoading(false)
  }

  const handleAddBilling = () => {
      addBillingForm.validateFields().then(values => {
        const data = {
          ...(type === "owner" ? { owner_id: values.tradename } : { tenant_id: values.tradename }),
          date_from: values.date_range[0].format('YYYY-MM-DD'),
          date_to: values.date_range[1].format('YYYY-MM-DD'),
          due_date: values.due_date.format('YYYY-MM-DD'),
          statement_date: values.statement_date.format('YYYY-MM-DD'),
          ...( values.remarks ? {remarks: values.remarks} : {remarks: ''}),
          rental_unit_id: unitId || values.rental_unit_id,
          grand_total:  grandTotal,
          source_ids: tenantBilling.map((item)=>item.id),
          type: tenantBilling.map((item)=>item.type),
          description: tenantBilling.map((item)=>item.description),
          principal_amount: tenantBilling.map((item)=>item.principal_amount),
          withholding_tax: tenantBilling.map((item)=>item.wtax),
          vat: tenantBilling.map((item)=>item.vat),
          discount_item_id: tenantBilling.map((item)=>item.discount_item_id || ''),
          discount_amount: tenantBilling.map((item)=>item.discount_amount),
          subtotal: tenantBilling.map((item)=>item.subtotal),
          amount_due: tenantBilling.map((item)=>item.amount_due),
        }

        const file = attachmentsData.map((file) => {
          return file.originFileObj;
        });

        var finalValues = Object.entries({...data, attachments: file}).map(([key, value]) => ({
            key,
            value,
        }));

        callPost(
            "billings/create", 
            finalValues,
            true,
        );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  // const disabledDate = (current) => {
  //   // Disable all days except the first and last days of the month
  //   return (
  //     !current.isSame(current.clone().startOf('month'), 'day') &&
  //     !current.isSame(current.clone().endOf('month'), 'day')
  //   );
  // };

  const normFile = (e) => {

    if (Array.isArray(e)) {
        setAttachmentsData(e)
    }
    setAttachmentsData(e?.fileList)
    
  };

  const grandTotal = tenantBilling?.reduce((total, item) => {
    // Convert amount to number and add to total
    return total + parseFloat(item.amount_due || 0);
  }, 0);

  useEffect(() => {
    fetchDiscountData();
    fetchBillingItem();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(type === "owner"){
      fetchOwnerData();
    }else{
      fetchTenantData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, unitId]);

  useEffect(() => {
    if(filterConfig.rental_unit_id && filterConfig?.tradename){
      fetchLastBilling();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [filterConfig]);

  React.useEffect(() => {
    fetchRentalData();
    fetchPropertyData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]); 

  const content = (
    <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
      <Space direction='vertical' span={6} className='p-1'>
        <Row>
          <Col span={24}>
            Tenant Name:<strong className='mx-2'>{ownerDetails?.tenant_name}</strong>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            Basic Rent:<strong className='mx-2'>{formatAmount(ownerDetails?.basic_rent )}</strong>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            Lease Term:<strong className='mx-2'>{ownerDetails?.lease_term} ({ownerDetails?.lease_type})</strong>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            Contract Period:<strong className='mx-2'>{ownerDetails?.contract_sign_date && formatDate(ownerDetails?.contract_sign_date)} - {ownerDetails?.contract_end_date && formatDate(ownerDetails?.contract_end_date)}</strong>
          </Col>
        </Row>
      </Space>
    </Row>
  );

return (
  <Layout className='page'>
      <Navbar/>
      <Layout className='content-container overflow-y'>
          <Row>
              <Col span={24} className='header-container p-3'>
                  ADD BILLING {type === "tenant" ? "(TENANT)" : "(OWNER)" }
              </Col>
          </Row>
          <Row>
              <Col span={24} className='p-3'>
                  <Form 
                    form={addBillingForm} 
                    layout="vertical" 
                    scrollToFirstError={true}
                    initialValues={location?.state ? location.state : {}}
                  >
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={6} className='p-1'>
                          <Item

                              label="Property"
                              name="property"
                              rules={[{ required: true, message: 'Please select your Property' }]} // Adjusted message
                          >
                              <Select 
                                placeholder="Select a property" 
                                onChange={(e) => handleProperty(e)}
                                showSearch
                                filterOption={(input, option) =>
                                  option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                              >
                                  {propertyData.map((option) => (
                                      <Option key={option.id} value={option.id}>{option.name}</Option>
                                  ))}
                              </Select>
                          </Item>
                        </Col>
                        <Col span={6} className='p-1'>
                          <Item
                              // label="Rental Unit"
                              label={
                                <Space>
                                  Rental Unit
                                  {
                                    (type === "owner" && ownerDetails.status === "occupied") && (
                                      <Button
                                        type="text"
                                        icon={<PersonPin />}
                                        style={{ fontSize:'1rem' }}
                                        onClick={handleOpenPin}
                                      />
                                    )
                                  }
                                </Space>
                              }
                              name="rental_unit_id"
                              rules={[{ required: true, message: 'Please select your Rental Unit' }]} // Adjusted message
                          >
                            <Select 
                              placeholder="Select a Rental Unit" 
                              onChange={(e) => handleRentalUnit(e)}
                              showSearch
                              filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {rentalData.map((option) => (
                                <Option key={option.id} value={option.id}>{option.name}</Option>
                              ))}
                            </Select>
                          </Item>
                        </Col>
                        <Col span={6} className='p-1'>
                          {
                            type === "tenant" ? (
                              <Item
                                label="Tenant Name"
                                name="tradename"
                                rules={[{ required: true, message: 'Please select your Tenant Name' }]}
                              >
                                <Select 
                                  placeholder="Select a Tenant Name" 
                                  onChange={(e) => handleTenant(e)}
                                  showSearch
                                  filterOption={(input, option) =>
                                      option?.children?.toLowerCase().includes(input.toLowerCase())
                                  }
                                  // disabled={(filterConfig.rental_unit_id === "") || (filterConfig.property_id === "")}
                                >
                                  {tenantData.map((option) => (
                                      <Option key={option.id} value={option.id}>{option.trade_name}</Option>
                                  ))}
                                </Select>
                              </Item>
                            ) : (
                              <Item
                                label="Owner Name"
                                name="tradename"
                                rules={[{ required: true, message: 'Please select your Owner Name' }]}
                              >
                                <Select
                                  placeholder="Select an Owner Name"
                                  onChange={(e) => handleTenant(e)}
                                  showSearch
                                  filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                  }
                                  // disabled={(filterConfig.rental_unit_id === "") || (filterConfig.property_id === "")}
                                >
                                  {tenantData.map((option) => (
                                    <Option key={option.id} value={option.id}>{option.name}</Option>
                                  ))}
                                </Select>
                              </Item>
                            )
                          }
                        </Col>
                        <Col span={6} className='p-1'>
                          <Item
                            label="Period Covered"
                            name="date_range"
                            rules={[{ required: true, message: 'Please select a date from' }]}
                          >
                            <RangePicker  
                              style={{width:'100%'}}
                              placeholder={['Covered Start', 'Covered End']}
                              // disabled={type === "tenant" ? [true, false] : false}
                              format={'YYYY/MM/DD'}
                              disabledDate={disabledDate}
                            />
                          </Item>
                        </Col>
                      {/* </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'> */}
                        {
                          type === "tenant" && (
                            <>
                              <Col span={6} className='p-1'>
                                <Item
                                  label="Corporate or Proprietor Name"
                                  name="business_name"
                                >
                                  <Input disabled/>
                                </Item>
                              </Col>
                              <Col span={6} className='p-1'>
                                <Item
                                    label="TIN Number"
                                    name="tin"
                                >
                                    <Input disabled/>
                                </Item>
                              </Col>
                              <Col span={6} className='p-1'>
                                <Item
                                    label="Tenant Remarks"
                                    name="tenant_remarks"
                                >
                                    <Input disabled/>
                                </Item>
                              </Col>
                            </>
                          )
                        }
                        <Col span={6} className='p-1'>
                          <Form.Item
                              label="Statement Date"
                              name="statement_date"
                              rules={[{ required: true, message: 'Please select a Statement Date' }]}
                          >
                              <DatePicker style={{ width: '100%' }} />
                          </Form.Item>
                        </Col>
                        <Col span={6} className='p-1'>
                          <Form.Item
                              label="Due Date"
                              name="due_date"
                              rules={[{ required: true, message: 'Please select a Due Date' }]}
                          >
                              <DatePicker style={{ width: '100%' }} />
                          </Form.Item>
                        </Col>
                        <Col span={16} className='p-1'>
                          <Item
                              label="Remarks"
                              name="remarks"
                          >                            
                            <TextArea/>
                          </Item>
                        </Col>
                        <Popover
                            placement="right"
                            content={content}
                            title="Tenant Info"
                            trigger="click"
                            open={open}
                          />   
                      </Row>
                      {/* {
                        (type === "owner" && ownerDetails.status === "occupied") && (
                          
                        )
                      } */}
                      <Row>
                          <Col span={24} className='p-2'>
                              List of Billing Items
                          </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                          <Col span={24} className='p-2'>
                            <Row>
                              <Col span={24} className='responsive-overflow-y'>
                                <Table
                                  // components={components}
                                  rowClassName={() => 'editable-row'}
                                  bordered
                                  dataSource={tenantBilling}
                                  columns={defaultColumns}
                                  loading={isLoading}
                                  pagination={false}
                                /> 
                              </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                              <Col span={12}>
                                <Button type="primary" onClick={addRow}>Add Row</Button>
                              </Col>
                              <Col span={12} className='amount-total' align='right'>
                                Total: {formatAmount(grandTotal)}
                              </Col>
                            </Row>
                          </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width my-3'>
                        <Col span={24} className='p-2'>
                          <Item 
                            label="Attachment"
                            name="attachments" 
                            // valuePropName="fileList" 
                            getValueFromEvent={normFile} 
                            noStyle
                          >
                            <Upload.Dragger 
                              multiple
                              name="files" 
                              // action="/upload.do"
                              fileList={attachmentsData}               
                              beforeUpload={() => false}
                              onRemove={handleDeleteAttachment}
                            >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                            <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                            </Upload.Dragger>
                          </Item>
                        </Col>
                      </Row>
                      <Row className='btn-footer'>
                        <Space className='p-2'>
                          <Button
                                onClick={type === "tenant" ? () => navigate('/billing') : () => navigate('/owner-billing')}
                                className='btn-header'
                          >
                            Close
                          </Button>
                      
                          <Button
                            onClick={handleAddBilling}
                            type='primary'
                            className='button-color btn-header'
                            disabled={isDisabled}
                            loading={loading}
                          >
                            Save
                          </Button>
                        </Space>
                      </Row>
                  </Form>
              </Col>
          </Row>
      </Layout>
  </Layout>
)
}

export default AddBilling
